// The one body of the rule that turns an email address into the canonical form this
// codebase stores and compares. Pure, and deliberately named for what it does rather
// than for any one screen that uses it — it used to live in `admin-change-email.ts`,
// where readers arriving from the sign-in path had to work out that it was not
// admin-specific (df-670aede0095d).

// Normalize an email address for storage and comparison: trim surrounding whitespace
// and lowercase, so Firebase Auth (which lowercases internally) and CouchDB _users (which
// stores raw) stay aligned.
//
// This is the canonical form, and a great deal depends on it. Changing what it does also
// changes: which account the by-email sign-in lookup finds, the claim key that stops a
// second account being created on one address, the Paddle webhook's version of that same
// claim key, the nightly job that reports a duplicate when one is created anyway, which
// rollout bucket a logged-in checkout lands in, the admin change-email screen's own
// validation, and the guard that decides whether the address a user typed is the account
// they are already signed in on. Those callers delegate here precisely so they cannot
// drift apart — so treat an edit here as an edit to all of them.
//
// Related but different, and NOT interchangeable with this:
// `normalizeEmailForAccountMatch` in `./subscription-ops-summary` reduces an address for
// FUZZY MATCHING and deliberately loses information, so it must never be written to a
// user record.
export function normalizeEmail(raw: string | undefined): string {
  return (raw || '').trim().toLowerCase();
}
